// extracted by mini-css-extract-plugin
export default {"searchBar":"search-bar_searchBar__bkKkY"};